import { Box, Container } from "@mui/material";
import { colors } from "../../theme/colors";
import { InternalLink } from "../utils/InternalLink";

export type BreadCrumb = {
  label: string;
  route: string;
};

type Props = {
  breadcrumbs: BreadCrumb[];
};

export const BreadCrumbs = ({ breadcrumbs }: Props) => {
  if (breadcrumbs.length === 0) {
    return null;
  }
  return (
    <Container sx={{ mb: { xs: 4, md: 8 } }}>
      <Box sx={{ position: "relative", width: "fit-content", py: 1, pr: 5 }}>
        <Box
          sx={{
            position: "absolute",
            height: "100%",
            right: 0,
            top: 0,
            background: colors.grey1,
            borderBottomRightRadius: 10,
            width: "10000rem"
          }}
        />
        {breadcrumbs.map((breadcrumb, index) => (
          <InternalLink
            key={index}
            to={breadcrumb.route}
            sx={{
              position: "relative",
              zIndex: 1,
              display: "inline",
              color: colors.grey4,
              "&:not(:last-child):after": {
                content: "'>'",
                margin: { xs: "0 0.5rem", md: "0 0.7rem" }
              },
              "&:last-child": {
                fontWeight: 600,
                color: colors.grey5
              }
            }}>
            {breadcrumb.label}
          </InternalLink>
        ))}
      </Box>
    </Container>
  );
};
